import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/view/home/index.vue'





// 查数据
import Ainformation from '@/view/Ainformation'

import school from '@/view/Ainformation/school.vue'//学校
import schoolInfo from '@/view/Ainformation/schoolInfo.vue'//学校

import schoolPath from '@/view/Ainformation/schoolPath.vue'//学校schoolPath 规划师跳转
import schoolInfoPath from '@/view/Ainformation/schoolInfoPath.vue'//学校详情schoolPath 规划师跳转



import major from '@/view/Ainformation/major.vue'//专业
import majorInfo from '@/view/Ainformation/majorInfo.vue'//专业详情

import majorPath from '@/view/Ainformation/majorPath.vue'//专业 规划师跳转
import majorInfoPath from '@/view/Ainformation/majorInfoPath.vue'//专业详情 规划师跳转


import occupation from '@/view/Ainformation/occupation.vue'//职业 
import occupationInfo from '@/view/Ainformation/occupationInfo.vue'//职业详情

import occupationPath from '@/view/Ainformation/occupationPath.vue'//职业 规划师跳转
import occupationInfoPath from '@/view/Ainformation/occupationInfoPath.vue'//职业详情 规划师跳转


import batchBorder from '@/view/Ainformation/batchBorder.vue'//批次线
import batchBorderPath from '@/view/Ainformation/batchBorderPath.vue'//批次线    规划师跳转





import subsection from '@/view/Ainformation/subsection.vue' //一分一段
import subsectionPath from '@/view/Ainformation/subsectionPath.vue' //一分一段 规划师跳转






import shamSchool from '@/view/Ainformation/shamSchool.vue' //虚假大学
import advance from '@/view/Ainformation/advance.vue' //提前批

import advancePath from '@/view/Ainformation/advancePath.vue' //提前批 规划师跳转

import video from '@/view/Ainformation/video.vue' //视频
import videoInfo from '@/view/Ainformation/videoInfo.vue' //视频

import userAgr from '@/view/Ainformation/userAgr.vue' //用户服务协议
import privacyAgr from '@/view/Ainformation/privacyAgr.vue' //隐私协议


// AI志愿
import AAIvol from '@/view/AAIvol'
import vol from '@/view/AAIvol/vol.vue'//填志愿页面
import myVol from '@/view/AAIvol/myVol.vue'//我的志愿

// 测评中心
import AAppraisal from '@/view/AAppraisal'
import appraisal from '@/view/AAppraisal/appraisal.vue'//填志愿页面


// 国际留学
import Ainternational from '@/view/Ainternational'
import AinIndex from '@/view/Ainternational/AinIndex.vue'







// import intoXueMeng from '@/view/intoxuemeng'
// import introduce from '@/view/intoxuemeng/introduce.vue'
// import develop from '@/view/intoxuemeng/develop.vue'
// import culture from '@/view/intoxuemeng/culture.vue'
// import concern from '@/view/intoxuemeng/concern.vue'
// import honor from '@/view/intoxuemeng/honor.vue'








// import NewsCenter from '@/view/NewsCenter'
// import businessAct from '@/view/NewsCenter/businessAct.vue'
// import groupAct from '@/view/NewsCenter/groupAct'
// import videoAll from '@/view/NewsCenter/videoAll.vue'
// import campusTale from '@/view/NewsCenter/campusTale.vue'

// 业务体系
// import WorkingSystem from '@/view/workingSystem'
// import WorkingSY from '@/view/workingSystem/shouye.vue'
// import WorkingItem from '@/view/workingSystem/workingItem.vue'

// 学历教育

// import XLJY from '@/view/Xuelijiaoyu'
// import CRGK from '@/view/Xuelijiaoyu/chengrengaokao.vue'
// import ZK from '@/view/Xuelijiaoyu/zikao.vue'
// import GJKF from '@/view/Xuelijiaoyu/guojiakaifang.vue'
// import DDZZ from '@/view/Xuelijiaoyu/dianda.vue'

// 职称申报
// import ZCSB from '@/view/zhichengshenbao'
// import ChuJi from '@/view/zhichengshenbao/chuji.vue'
// import ZhongJi from '@/view/zhichengshenbao/zhongji.vue'
// import GaoJi from '@/view/zhichengshenbao/gaoji.vue'
// import ZhengGaoJi from '@/view/zhichengshenbao/zhenggaoji.vue'


// 职业教育
// import ZYJY from '@/view/zhiyejiaoyu'
// import xuexiao from '@/view/zhiyejiaoyu/zhiyexuexiao.vue'
// import peixun from '@/view/zhiyejiaoyu/zhiyepeixun.vue'

// 学盟服务
// import XMFU from '@/view/xuemengfuwu'
// import fourSer from '@/view/xuemengfuwu/fourSer.vue'
// import selectXm from '@/view/xuemengfuwu/selectXm.vue'
// import mienXm from '@/view/xuemengfuwu/mienXm.vue'
// 专升本
// import ZSB from '@/view/zhuanshengben'


// 成考院校
// import CKYX from '@/view/yuanxiao'
// import xiangqing from '@/view/yuanxiao/chengkaoyuanxiao'

// 集团团建
// import league from '@/view/league'
// 联系我们
// import contact from '@/view/contact'
// 用户服务
// import User from '@/view/user'

// 照片
// import chengkao from '@/view/pic/chengkao'
// import guojiakaifang from '@/view/pic/guojiakaifang'
// import shenbao from '@/view/pic/shenbao'

// 新闻中心
// import jituanItem from '@/view/xinwenzhongxinItem/jituanItem'
// import hangyeItem from '@/view/xinwenzhongxinItem/hangyeItem'
// import shipinItem from '@/view/xinwenzhongxinItem/shipinItem'
// import xiaoquItem from '@/view/xinwenzhongxinItem/xiaoquItem'
// import kongbai from '@/view/xinwenzhongxinItem/kongbai.vue'




Vue.use(VueRouter)
const routes = [
    {
        path: '/',
        component: Home
        // redirect: '/home'
    },
    // {
    //     path: '/',
    //     component: Home
    // },
    // 查数据
    {
        path: '/Ainformation',
        component: Ainformation,
        redirect: '/Ainformation/school',
        children: [
			// 学校
            {
                path: 'school',
                name: 'school',
                component: school,
            },
			// 学校详情
			{
			    path: 'schoolInfo',
			    name: 'schoolInfo',
			    component: schoolInfo,
			},
			
			// 学校 规划师跳转
			{
			    path: 'schoolPath',
			    name: 'schoolPath',
			    component: schoolPath,
				meta:{showHeader:false}
			},
			// 学校详情 规划师跳转详情
			{
			    path: 'schoolInfoPath',
			    name: 'schoolInfoPath',
			    component: schoolInfoPath,
				meta:{showHeader:false}
			},
			
			
			
			// 专业
            {
                path: 'major',
                name: 'major',
                component: major,
            },
			// 专业详情
			{
			    path: 'majorInfo',
			    name: 'majorInfo',
			    component: majorInfo,
			},
			
			// 专业 规划师跳转
			{
			    path: 'majorPath',
			    name: 'majorPath',
			    component: majorPath,
				meta:{showHeader:false}
			},
			// 专业详情 规划师跳转
			{
			    path: 'majorInfoPath',
			    name: 'majorInfoPath',
			    component: majorInfoPath,
				meta:{showHeader:false}
			},
			
			
			
			
			
			
			
			
			
			
			
			//职业
			{
			    path: 'occupation',
			    name: 'occupation',
			    component: occupation,
			},
			//职业详情
			{
			    path: 'occupationInfo',
			    name: 'occupationInfo',
			    component: occupationInfo,
			},
			
			// 职业 规划师跳转
			{
			    path: 'occupationPath',
			    name: 'occupationPath',
			    component: occupationPath,
				meta:{showHeader:false}
			},
			// 职业详情 规划师跳转
			{
			    path: 'occupationInfoPath',
			    name: 'occupationInfoPath',
			    component: occupationInfoPath,
				meta:{showHeader:false}
			},
			
			
			
			
			
			
			
			// 批次线
			{
			    path: 'batchBorder',
			    name: 'batchBorder',
			    component: batchBorder,
			},
			// 批次线 规划师跳转用
			{
			    path: 'batchBorderPath',
			    name: 'batchBorderPath',
			    component: batchBorderPath,
				meta:{showHeader:false}
			},
			
			
			
			
			// 一分一段
			{
			    path: 'subsection',
			    name: 'subsection',
			    component: subsection,
			},
			// 一分一段 规划师跳转
			{
			    path: 'subsectionPath',
			    name: 'subsectionPath',
			    component: subsectionPath,
				meta:{showHeader:false}
			},
			
			
			
			
			// 虚假大学
			{
			    path: 'shamSchool',
			    name: 'shamSchool',
			    component: shamSchool,
			},
			// 提前批
			{
			    path: 'advance',
			    name: 'advance',
			    component: advance,
			},
			// 提前批 规划师跳转
			{
			    path: 'advancePath',
			    name: 'advancePath',
			    component: advancePath,
				meta:{showHeader:false}
			},
			
			
			
			
			
			
			// 视频
			{
			    path: 'video',
			    name: 'video',
			    component: video,
			},
			// 视频播放
			{
			    path: 'videoInfo',
			    name: 'videoInfo',
			    component: videoInfo,
			},
			// 用户服务协议
			{
			    path: 'userAgr',
			    name: 'userAgr',
			    component: userAgr,
			},
			// privacyAgr 隐私协议
			{
			    path: 'privacyAgr',
			    name: 'privacyAgr',
			    component: privacyAgr,
			},
			
        ]
    },
	// AI志愿
	{
	    path: '/AAIvol',
	    component: AAIvol,
	    redirect: '/AAIvol/vol',
	    children: [
			// 计划
	        {
	            path: 'vol',
	            name: 'vol',
	            component: vol,
	        },
			// 我的计划
			{
			    path: 'myVol',
			    name: 'myVol',
			    component: myVol,
			},
	    ]
	},
	// 测评中心
	{
	    path: '/AAppraisal',
	    component: AAppraisal,
	    redirect: '/AAppraisal/appraisal',
	    children: [
			// 测评页面
	        {
	            path: 'appraisal',
	            name: 'appraisal',
	            component: appraisal,
	        },
	    ]
	},
	// 国际留学
	{
	    path: '/Ainternational',
	    component: Ainternational,
	    redirect: '/Ainternational/AinIndex',
	    children: [
	        // 首页
	        {
	            path: 'AinIndex',
	            name: 'AinIndex',
	            component: AinIndex,
	            // hidden:true
	        },]
	},
	
	// import Ainternational from '@/view/Ainternational'
	// import AinIndex from '@/view/Ainternational/AinIndex.vue'
	
	
	
    // // 新闻中心
    // {
    //     path: '/NewsCenter',
    //     component: NewsCenter,
    //     redirect: '/NewsCenter/groupAct',
    //     children: [
    //         {
    //             path: 'groupAct',
    //             name: 'groupAct',
    //             component: groupAct,
    //         },
    //         {
    //             path: 'businessAct',
    //             name: 'businessAct',
    //             component: businessAct,
    //         },
    //         {
    //             path: 'videoAll',
    //             name: 'videoAll',
    //             component: videoAll,
                
    //         },
    //         {
    //             path: 'campusTale',
    //             name: 'campusTale',
    //             component: campusTale,
                
    //         },

    //     ]
    // },

    // // 每一项
    // {
    //     path: '/jituanItem',
    //     name: 'jituanItem',
    //     component: jituanItem,
    // }
    // ,
    // {
    //     path: '/hangyeItem',
    //     name: 'hangyeItem',
    //     component: hangyeItem,
    // }
    // ,
    // {
    //     path: '/shipinItem',
    //     name: 'shipinItem',
    //     component: shipinItem,
    // }
    // ,
    // {
    //     path: '/xiaoquItem',
    //     name: 'xiaoquItem',
    //     component: xiaoquItem,
    // },
    // // 空白
    // // {
    // //     path: '/kongbai',
    // //     name: 'kongbai',
    // //     component: kongbai,
    // // },

    // // 业务体系
    // {
    //     path: '/WorkingSystem',
    //     component: WorkingSystem,
    //     redirect: '/WorkingSystem/WorkingSY',
    //     children: [
    //         // 首页
    //         {
    //             path: 'WorkingSY',
    //             name: 'WorkingSY',
    //             component: WorkingSY,
    //             // hidden:true
    //         },

    //         // 每一项
    //         {
    //             path: 'WorkingItem',
    //             name: 'WorkingItem',
    //             component: WorkingItem,
    //             // hidden: true

    //         },
    //         // 学历教育
    //         {
    //             path: 'XLJY',
    //             component: XLJY,
    //             redirect: '/WorkingSystem/XLJY/CRGK',
    //             children: [
    //                 {
    //                     path: 'CRGK',
    //                     component: CRGK
    //                 },
    //                 {
    //                     path: 'ZK',
    //                     component: ZK
    //                 },
    //                 {
    //                     path: 'GJKF',
    //                     component: GJKF
    //                 },
    //                 {
    //                     path: 'DDZZ',
    //                     component: DDZZ
    //                 }
    //             ]
    //         },
    //         // 职称申报
    //         {
    //             path: 'ZCSB',
    //             component: ZCSB,
    //             redirect: '/WorkingSystem/ZCSB/ChuJi',
    //             children: [
    //                 {
    //                     path: 'ChuJi',
    //                     component: ChuJi
    //                 },
    //                 {
    //                     path: 'ZhongJi',
    //                     component: ZhongJi
    //                 },
    //                 {
    //                     path: 'GaoJi',
    //                     component: GaoJi
    //                 },
    //                 {
    //                     path: 'ZhengGaoJi',
    //                     component: ZhengGaoJi
    //                 },

    //             ]
    //         },
    //         // 职业教育
    //         {
    //             path: 'ZYJY',
    //             component: ZYJY,
    //             redirect: '/WorkingSystem/ZYJY/xuexiao',
    //             children: [
    //                 {
    //                     path: 'xuexiao',
    //                     component: xuexiao
    //                 },
    //                 {
    //                     path: 'peixun',
    //                     component: peixun
    //                 },

    //             ]
    //         },
    //         // 专升本
    //         {
    //             path: 'ZSB',
    //             component: ZSB,
    //         },
    //         // 成考院校
    //         {
    //             path: 'CKYX',
    //             component: CKYX,
    //             alwaysShow: true,
    //             meta: {
    //                 showfater: true
    //             },
    //             children: [{
    //                 path: 'xiangqing',
    //                 name: 'xiangqing',
    //                 component: xiangqing,
    //                 meta: {
    //                     showfater: false
    //                 }
    //             }]
    //         },

    //     ]
    // },
    // // 学盟服务

    // {
    //     path: '/XMFU',
    //     component: XMFU,
    //     redirect: '/XMFU/fourSer',
    //     children: [
    //         {
    //             path: 'fourSer',
    //             name: 'fourSer',
    //             component: fourSer,
    //         },
    //         {
    //             path: 'selectXm',
    //             name: 'selectXm',
    //             component: selectXm,
    //         },
    //         {
    //             path: 'mienXm',
    //             name: 'mienXm',
    //             component: mienXm,
    //         }
    //     ]
    // },
    // // 团建
    // {
    //     path: '/league',
    //     component: league,
    // },
    // // 联系我们
    // {
    //     path: '/contact',
    //     component: contact,
    // },
    // // 用户服务
    // // {
    // //     path: '/User',
    // //     component: User,
    // // },
    // {
    //     path: '/Chengkao',
    //     component: chengkao,
    // },
    // {
    //     path: '/Guojiakaifang',
    //     component: guojiakaifang,
    // },
    // {
    //     path: '/shenbao',
    //     component: shenbao,
    // },



]



const router = new VueRouter({
    mode: 'history',
    routes
})
router.beforeEach((to, from, next) => {
	console.log('to',to)
  if (to.path === '/logout' || to.meta.clearCache) {
    // 执行清除缓存的逻辑，例如调用Vuex的action
    store.dispatch('clearCache');
  }
  next();
});
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}


export default router